import { ApiRequestError } from "@/lib/api/client";
import { MediaError } from "@/lib/webrtc/MediaStreamManager";
import type { MessageKey } from "@/lib/i18n/en";
import type { Translate } from "@/lib/i18n";
import { SocketError } from "@/lib/socket/wsClient";

const TRANSLATABLE = new Set<string>([
  "unauthorized",
  "forbidden",
  "not_found",
  "bad_credentials",
  "email_taken",
  "registration_closed",
  "session_expired",
  "session_revoked",
  "room_full",
  "guests_not_allowed",
  "host_absent",
  "meeting_cancelled",
  "bad_passcode",
  "bad_code",
  "already_sharing",
  "no_media_server",
  "media_error",
  "recording_disabled",
  "already_joined",
  "no_board",
  "not_presenting",
  "record_failed",
  "too_long",
  "conversion_unavailable",
  "too_large",
  "unsupported_type",
  "too_many_rooms",
  "network_error",
  "unavailable",
  "timeout",
  "disconnected",
]);

export function describeError(error: unknown, t: Translate): string {
  const fromServer = error instanceof ApiRequestError || error instanceof SocketError;
  const code = fromServer ? error.code : "";

  if (TRANSLATABLE.has(code)) return t(`error.${code}` as MessageKey);

  if (error instanceof MediaError) return t(`error.media_${error.reason}`);

  if (fromServer && error.message !== "") return error.message;

  return t("common.somethingWentWrong");
}
